import "./InputAnalysisAndAgentSelection.module.css";
import Header from "@/reusable_sections/Header";
import About from "./sections/About";
import HowItWorks from "./sections/HowItWorks";
import AgentOptions from "./sections/AgentOptions";
import Footer from "@/reusable_sections/Footer";
export default function InputAnalysisAndAgentSelectionPage() {
  return <div>
      <Header />
      <About />
      <HowItWorks />
      <AgentOptions />
      <Footer />
    </div>;
}